import type { Destination, DestinationKind } from '@/shared/model';
import type { OptionGroup } from '../model/types';

const KIND_ORDER: readonly DestinationKind[] = ['country', 'resort', 'hotel'];

/**
 * Группирует результаты интеллектуального поиска (intelligentSearch) по типу
 * — страна → курорт → отель — СОХРАНЯЯ порядок бэкенда внутри каждого типа.
 *
 * Бэкенд уже ранжирует подсказки по релевантности/популярности (например
 * «Q Premium Resort» первым по точному вхождению, «Utopia World» выше «Utopia
 * (Утопия), Баку»). В отличие от списка обзора направлений (см. sortOptions,
 * где алфавит уместен), результаты поиска пересортировывать нельзя — иначе
 * ранжирование бэкенда затирается.
 */
export function groupOptions(items: Destination[]): OptionGroup[] {
  const groups: OptionGroup[] = [];

  for (const kind of KIND_ORDER) {
    const ofKind = items.filter((item) => item.type === kind);
    if (ofKind.length > 0) {
      groups.push({ title: null, kind, items: ofKind });
    }
  }

  return groups;
}
